import { useEffect } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";
import { useMaterialUIController, setLayout } from "../../context";
import MaterialBox from "../../components/MaterialBox";
import DashboardFooter from "./components/Footer";
import DashboardNavbar from "./components/Navbar";
import { Logout } from "../../BaseUrl";
import { UserLogout } from "../../pages/authentication/Mutation";

function DashboardLayout({
  children,
  searchdata,
  setsearchdata,
  setOpenFilter,
  setOpenExport,
  name,
}) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav } = controller;
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);

  return (
    <MaterialBox
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
        // p: 3,
        position: "relative",

        [breakpoints.up("xl")]: {
          marginLeft: miniSidenav ? pxToRem(120) : pxToRem(254),
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      })}
    >
      <DashboardNavbar
        searchdata={searchdata}
        name={name}
        setsearchdata={setsearchdata}
        setOpenExport={setOpenExport}
        setOpenFilter={setOpenFilter}
        Logout={Logout}
        UserLogout={UserLogout}
      />
      <div style={{ minHeight: "74vh", marginTop: "1rem" }}>{children}</div>
      <MaterialBox
        sx={{ paddingTop: (theme) => `${theme.spacing(9)} !important` }}
      >
        <DashboardFooter />
      </MaterialBox>
    </MaterialBox>
  );
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
